/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

/**
 * Centralized chart series colors so sparklines across Server Overview,
 * kiosk widgets, and detail tabs read consistently instead of each
 * component hardcoding its own hex value.
 */
// "Grid" skin: near-monochrome + one signal green. Series that never share
// a chart all use the signal colour; where two series overlap (network
// in/out) the secondary drops to a muted neutral, and temperature keeps the
// "warning" amber since it reads as a threshold gauge.
export const CHART_COLORS = {
  cpu: "#86b9a0",
  memory: "#86b9a0",
  disk: "#86b9a0",
  temperature: "#d9b26a",
  networkIn: "#86b9a0",
  networkOut: "#6e7d77",
} as const;
